/* eslint-disable complexity */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-restricted-imports */
/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { useProductDetails } from '@/data/Content/ProductDetails';
import { ID } from '@/data/types/Basic';
import React, { FC } from 'react';
import { Bundle } from '@/components/content/Bundle';
import { useIsMobile } from '@/data/hooks/useIsMobile';
import { ProductDetailsSkeleton } from '@/components/content/ProductDetails/parts/ProductDetailsSkeleton';
import { ProductDetails } from '@/components/content/ProductDetails';
import { OpenGraphMetadata } from '@/components/blocks/OpenGraph';
import {
	extractCodeFromPath,
	getImageUrl,
	IMAGE_DEFAULT_URL,
} from '@/components/blocks/ProductDetails/Gallery';

export const ProductDetailsMain: FC<{
	id: ID;
}> = ({ id }) => {
	const isMobile = useIsMobile();
	const productDetails = useProductDetails({ partNumber: id.toString() });

	if (productDetails.loading) {
		return <ProductDetailsSkeleton isMobile={isMobile} />;
	}

	if (productDetails.isBundle) {
		return <Bundle id={id} />;
	}

	const sku = productDetails.selection?.sku || productDetails.product;
	const image = getImageUrl(IMAGE_DEFAULT_URL, extractCodeFromPath(sku?.thumbnail ?? '') ?? '', 1);

	return (
		<>
			<OpenGraphMetadata image={image} type="product" />
			<ProductDetails id={id} />
		</>
	);
};
